export const ERROR = "ERROR";
export const LOGOUT = "LOGOUT";
export const ADDTOCART = "ADDTOCART";
export const DELFROMCART = "DELFROMCART";
export const INCREASECART = "INCREASECART";
// export const DECREASECART = "DECREASECART";
export const SETUSER = "SETUSER";
export const SETSHIPADDRESS = "SETSHIPADDRESS";
export const CHECKOUTDONE = "CHECKOUTDONE";
export const GENDERFILTER = "GENDERFILTER";
export const BRANDFILTER = "BRANDFILTER";
export const PRICEFILTER = "PRICEFILTER";
export const CLEARFILTER = "CLEARFILTER";
export const SETTOKEN = "SETTOKEN";
